import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="qx-footer">
      <div className="qx-footer-inner">
        <div className="qx-footer-left">
          © {year} QuasarX. All rights reserved.
        </div>

        <div className="qx-footer-right">
          <a href="/blog">Blog</a>
          <span className="qx-footer-sep">•</span>
          <a href="/about">About</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
